import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "unfold",
  "use": "unfold-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol viewBox=\"0 0 20 16\" id=\"unfold\">\n<defs>\n    <style>\n      #unfold .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M3187,66h18a1,1,0,1,1,0,2h-18A1,1,0,1,1,3187,66Zm0,14h18a1,1,0,1,1,0,2h-18A1,1,0,1,1,3187,80Zm-0.58-8.99h9.16a1.4,1.4,0,0,1,0,2h-9.16A1.4,1.4,0,0,1,3186.42,71.01Zm0,3.979h9.16a1.4,1.4,0,0,1,0,2h-9.16A1.4,1.4,0,0,1,3186.42,74.99ZM3201.5,71l3.5,6h-7Z\" transform=\"translate(-3186 -66)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/unfold.svg
// module id = vD+H
// module chunks = 264